import { render, staticRenderFns } from "./ImageWithDesc.vue?vue&type=template&id=b8aa268a&scoped=true"
import script from "./ImageWithDesc.vue?vue&type=script&lang=ts"
export * from "./ImageWithDesc.vue?vue&type=script&lang=ts"
import style0 from "./ImageWithDesc.vue?vue&type=style&index=0&id=b8aa268a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aa268a",
  null
  
)

export default component.exports